import gql from 'graphql-tag';

export default gql`
  mutation preEnrollCustomer($email: String!, $memberSourceAndDeviceType: String) {
    preEnrollCustomer(email: $email, memberSourceAndDeviceType: $memberSourceAndDeviceType) {
      loyaltyID
    }
  }
`;
